<template>
  <div class="date-time-interval d-flex flex-column">
    <el-tooltip :content="fromPlaceholder" placement="top" effect="light" :open-delay="300" transition="el-zoom-in-top">
      <el-time-picker
        v-model="from"
        :data-id="`${name}-from`"
        clearable
        :placeholder="fromPlaceholder"
        :format="getTimeFormat"
        :picker-options="options"
        :value-format="valueFormat"
        @change="onChange($event, 'from')"
      >
      </el-time-picker>
    </el-tooltip>
    <el-tooltip
      :content="toPlaceholder"
      placement="bottom"
      effect="light"
      :open-delay="300"
      transition="el-zoom-in-top"
    >
      <el-time-picker
        v-model="to"
        :data-id="`${name}-to`"
        clearable
        :placeholder="toPlaceholder"
        :format="getTimeFormat"
        :picker-options="options"
        :value-format="valueFormat"
        @change="onChange($event, 'to')"
      >
      </el-time-picker>
    </el-tooltip>
  </div>
</template>

<script>
import intervalMixin from './mixin-interval'

export default {
  name: 'FilterTime',
  mixins: [intervalMixin],
  data() {
    return {
      valueFormat: 'HH:mm:ss',
      from: '',
      to: '',
      fromPlaceholder: this.$i18n.t('time_interval_start'),
      toPlaceholder: this.$i18n.t('time_interval_end'),
    }
  },
  computed: {
    getTimeFormat() {
      let format = 'HH:mm:ss'
      if (this.$CORE.language.code === 'en-US') {
        format = 'hh:mm:ss A'
      }
      return format
    },
    options() {
      return {
        format: this.getTimeFormat,
      }
    },
  },
}
</script>
